const PIN_ELIGIBILITY_REASONS = {
  UNRESTRICTED: 'unrestricted',
  WRONG_DOMAIN: 'wrong_domain',
  NOT_IN_ELIGIBLE_PRODUCTS: 'not_in_eligible_products',
  NO_URL_STEM: 'no_url_stem',
  INVALIDATED_BY_BRAND: 'invalidated_by_brand'
};

const PRODUCT_SCOPE_MESSAGES = {
  LINKS_EXPECTATION_REQUIRED:
    'Product-restricted opportunities require a links expectation. Set the expected number of links above zero before selecting products.',
  CODE_ONLY_ORDERS_WHILE_RESTRICTED:
    'Code-only orders are not linked to specific products. Code-only orders cannot count while this opportunity is restricted to catalog groups.',
  ACCEPTABLE_DOMAINS_WHILE_RESTRICTED:
    'Acceptable domains cannot be changed while this opportunity is restricted to selected products. Only links to the brand website count.',
  CANNOT_RESTRICT_AFTER_SEND:
    'Products cannot be restricted after creators have been invited or a plan has been sent. Duplicate the opportunity to start a restricted campaign.',
  CANNOT_UNBIND_AFTER_SEND: 'Selected product groups cannot be removed after creators have been invited or a plan has been sent.',
  BINDING_AFTER_CUTOFF: 'The settlement cutoff for this opportunity has passed, so its product selection can no longer change.',
  ELIGIBILITY_CHECK_FAILED: 'Unable to check link eligibility right now. Please try again.',
  DESTINATION_EDIT_BLOCKED:
    'This link is being considered for an active opportunity. You can edit its destination again once the opportunity is finalized.'
};

module.exports = { PIN_ELIGIBILITY_REASONS, PRODUCT_SCOPE_MESSAGES };
